import { Box, Typography } from '@mui/material';
import { Chart, ChartOption } from '@/components/Base/Chart';
import type { HeatmapResponse } from '../types';

interface Props {
  data: HeatmapResponse | undefined;
}

const TURMA_ALLOW = /ano|s[eé]rie|infantil/i;

const HeatmapTurmaDisciplina: React.FC<Props> = ({ data }) => {
  if (!data) {
    return (
      <Box
        sx={{
          background: '#fff',
          borderRadius: '14px',
          border: '1px solid rgba(176, 176, 176, 1)',
          p: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        height="400px"
      >
        <Typography color="#999" fontSize={14}>
          Carregando mapa de calor...
        </Typography>
      </Box>
    );
  }

  // Manter apenas turmas que contenham "ano", "série"/"serie" ou "infantil"
  const allowedIndexes: number[] = [];
  const filteredTurmas: string[] = [];
  data.turmas.forEach((turma, idx) => {
    if (TURMA_ALLOW.test(turma)) {
      allowedIndexes.push(idx);
      filteredTurmas.push(turma);
    }
  });

  const chartData = data.dados
    .filter((d) => allowedIndexes.includes(d.turma_index))
    .map((d) => [
      d.disciplina_index,
      allowedIndexes.indexOf(d.turma_index),
      d.media,
    ]);

  const option: ChartOption = {
    title: {
      text: 'Mapa de Calor: Turma × Disciplina',
      textStyle: { fontSize: 14 },
    },
    tooltip: {
      position: 'top',
      formatter: (params: any) => {
        const [xIdx, yIdx, val] = params.value;
        return `${filteredTurmas[yIdx]} — ${data.disciplinas[xIdx]}: <b>${val}</b>`;
      },
    },
    grid: { left: '18%', top: '60px', right: '8%', bottom: '60px' },
    xAxis: {
      type: 'category',
      data: data.disciplinas,
      splitArea: { show: true },
      axisLabel: { rotate: 30, fontSize: 11 },
    },
    yAxis: {
      type: 'category',
      data: filteredTurmas,
      splitArea: { show: true },
    },
    visualMap: {
      min: 0,
      max: 10,
      calculable: true,
      orient: 'horizontal',
      left: 'center',
      bottom: '0%',
      inRange: {
        color: ['#DF4A4C', '#FDC500', '#1c9c7c'],
      },
    },
    series: [
      {
        type: 'heatmap',
        data: chartData,
        label: {
          show: true,
          formatter: (params: any) => params.value[2],
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid rgba(176, 176, 176, 1)',
        p: '20px',
      }}
      height="400px"
    >
      <Chart option={option} />
    </Box>
  );
};

export default HeatmapTurmaDisciplina;
